<template>
  <div class="rating-header">
    <div class="rating-header__block">
      <UiSelectFilter
        class="rating-header__item -m-"
        title="Выбор курса"
        placeholder="Все курсы"
        :option="folders"
        :value="filterList.folders"
        :smart="true"
        :can-unset="true"
        unset-text="Все курсы"
        :max-height="200"
        @input="setFilter('folders', $event)"
      />
      <!--Убрал, так как бэк сейчас не поддерживает фильтрацию по неделям
      <UiSelect
        class="rating-header__item -m-"
        title="Выбор недели"
        placeholder="Все недели"
        :option="weekList"
        :value="filterList.week"
        :smart="true"
        :can-unset="true"
        unset-text="Все недели"
        :unset-value="''"
        :max-height="200"
        @input="setFilter('week', $event)"
      />
      -->
      <UiInput
        class="rating-header__item -l-"
        title="Найти участника"
        icon="ui-search"
        placeholder="Введите имя участника"
        :value="filterList.search"
        @input="setFilter('search', $event)"
      />
      <UiSelectFilter
        v-if="captainList.length"
        class="rating-header__item -m-"
        title="Найти капитана"
        placeholder="Введите имя капитана"
        :value="filterList.captain"
        :option="captainList"
        :smart="true"
        :can-unset="true"
        :max-height="200"
        @input="setFilter('captain', $event)"
      />
      <UiSelectFilter
        v-if="cityList.length"
        class="rating-header__item -m-"
        title="Выбрать город"
        placeholder="Введите город"
        :value="filterList.city"
        :option="cityList"
        :smart="true"
        :can-unset="true"
        :max-height="200"
        @input="setFilter('city', $event)"
      />
      <UiSelectFilter
        v-if="cityList.length"
        class="rating-header__item -m-"
        title="Выбрать факультет/сборную"
        placeholder="Введите факультет/сборную"
        :value="filterList.faculty"
        :option="facultyList"
        :smart="true"
        :can-unset="true"
        :max-height="200"
        @input="setFilter('faculty', $event)"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import replaceMultipleRouteQuery from '@/functions/replaceMultipleRouteQuery';

export default {
  data: () => ({
    isShowModal: false,
    weekList: [
      {
        value: '-1',
        title: 'До курса'
      },
      {
        value: '0',
        title: 'Неделя 1'
      },
      {
        value: '1',
        title: 'Неделя 2'
      },
      {
        value: '2',
        title: 'Неделя 3'
      },
      {
        value: '3',
        title: 'Неделя 4'
      },
      {
        value: '4',
        title: 'Неделя 5'
      },
      {
        value: '5',
        title: 'Неделя 6'
      }
    ]
  }),
  computed: {
    ...mapState('ratingTeams', {
      isGroupLoading: s => s.meta.isGroupLoading,
      filterList: s => s.data.filterList,
      folders: s =>
        s.data.settings.folders.map(folder => ({
          value: String(folder.id),
          title: folder.name
        })),
      cityList: s =>
        s.data.settings.cities.map(item => ({
          value: String(item),
          title: item
        })),
      facultyList: s =>
        s.data.settings.faculties.map(item => ({
          value: item.name,
          title: item.name
        })),
      captainList: s =>
        s.data.settings.captains.map(item => ({
          value: String(item.id),
          title: `${item.name} ${item.lastname}`
        }))
    }),
    ...mapState('auth', {
      isAdmin: s => s.data.user.permissions.isAdmin,
      user: s => s.data.user,
      isLoadingUser: s => s.meta.loading
    })
  },
  watch: {
    filterList: {
      handler: function (value) {
        this.setUrl(value);
        this.getTeamGroupData();
      },
      deep: true
    }
  },
  created() {
    this.initData();
  },
  methods: {
    openModal() {
      this.isShowModal = true;
    },
    clearTeamList() {
      this.$store.dispatch('ratingTeams/clearTeamList');
    },
    setFilter(path, value) {
      this.$store.dispatch('ratingTeams/setFilter', { path, value });
    },
    getTeamGroupData() {
      this.$store.dispatch('ratingTeams/getTeamGroupData');
    },
    setUrl(queryList) {
      replaceMultipleRouteQuery(
        Object.entries(queryList).map(([name, value]) => ({
          value,
          name,
          method: 'replace'
        }))
      );
    },
    initData() {
      this.$store.dispatch('ratingTeams/getSettings');
      this.getUrlQuery();
      setTimeout(() => {
        if (!this.isGroupLoading) {
          this.getTeamGroupData();
        }
      }, 0);
    },
    getUrlQuery() {
      const initFilters = {};
      Object.keys(this.filterList).forEach(key => {
        if (key in this.$route.query) {
          initFilters[key] = this.$route.query[key];
        }
      });

      this.$store.dispatch('ratingTeams/initFilter', initFilters);
    }
  }
};
</script>
